import { Untersuchungsmaterial } from '../../untersuchungsmaterialien/untersuchungsmaterial';
import { API_BASE_URL_SERVICE } from '../../../../../projects/kiene-core/src/lib/kiene-core.config';
import { KieneBackendApiService } from '../../../../../projects/kiene-core/src/lib/services/backend-api/kiene-backend-api.service';
import { FormControl } from '@angular/forms';
import { MessageService } from '../../../../../projects/kiene-core/src/lib/services/message-service/message.service';
import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { KieneUtils } from '../../../../../projects/kiene-core/src/lib/utils/KieneUtils';

@Component({
    selector: 'kiene-materialien-filter-dialog',
    templateUrl: './materialien-filter-dialog.component.html',
    styleUrls: ['./materialien-filter-dialog.component.scss'],
})
export class MaterialienFilterDialogComponent implements OnInit {
    materialien: Untersuchungsmaterial[] = [];
    materialienCtrl: FormControl = new FormControl();

    constructor(
        public dialogRef: MatDialogRef<MaterialienFilterDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public selected: Untersuchungsmaterial[], // Eingabedaten mit ausgewählten Materialien
        private readonly api: KieneBackendApiService,
        @Inject(API_BASE_URL_SERVICE) private readonly apiBaseUrl: string,
        private readonly messageService: MessageService,
    ) {}

    ngOnInit(): void {
        this.ladeMaterialien();
    }

    private ladeMaterialien(): void {
        this.api.getAll(this.apiBaseUrl + 'untersuchungsmaterial/read.php').subscribe({
            next: response => {
                this.materialien = response.records;
                this.materialienCtrl.setValue(this.reconcileSelectedMaterialien(this.selected));
            },
            error: error => {
                this.messageService.errorMessage('Fehler beim Laden der Untersuchungsmaterialien', error);
            },
        });
    }

    materialienComparator = (o1: Untersuchungsmaterial, o2: Untersuchungsmaterial) =>
        KieneUtils.sameId(o1?.untersuchungsmaterial_id, o2?.untersuchungsmaterial_id);

    private reconcileSelectedMaterialien(selected: Untersuchungsmaterial[]): Untersuchungsmaterial[] {
        if (!selected?.length) {
            return [];
        }
        return selected.map(s =>
            this.materialien.find(m => KieneUtils.sameId(m.untersuchungsmaterial_id, s.untersuchungsmaterial_id)) ?? s,
        );
    }

    public submit(): void {
        const materialienFilterDialogResult = new MaterialienFilterDialogResult();
        materialienFilterDialogResult.selectedMaterialien = this.materialienCtrl?.value;
        materialienFilterDialogResult.confirm = true;
        this.dialogRef.close(materialienFilterDialogResult);
    }

    public reset(): void {
        this.materialienCtrl.setValue([]);
    }

    public cancel(): void {
        const materialienFilterDialogResult = new MaterialienFilterDialogResult();
        materialienFilterDialogResult.confirm = false;
        this.dialogRef.close(materialienFilterDialogResult);
    }
}

export class MaterialienFilterDialogResult {
    selectedMaterialien: Untersuchungsmaterial[] = [];
    confirm: boolean;
}
